import { getTheme, Icon, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import React from 'react';

export interface IPRIVATE_ADDITIONAL_INFO_LABELProps {
  icon: string;
  iconColor?: string;
  text: string;
}

const getStyles = (theme: ITheme, iconColor?: string) => {
  const main: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: '1em',
    alignItems: 'center',
    color: theme.palette.neutralSecondary,
    fontSize: '0.9em',
    margin: 0,
    marginTop: '0.85em',
    padding: 0,
  };

  const icon: IStyle = {
    color: iconColor,
    fontSize: '1.2em',
  };

  return mergeStyleSets({
    main,
    icon,
  });
}

export const PRIVATE_ADDITIONAL_INFO_LABEL: React.FunctionComponent<IPRIVATE_ADDITIONAL_INFO_LABELProps> = (props) => {
  const theme = getTheme();
  const styles = getStyles(theme, props.iconColor);

  return (
    <p className={styles.main}>
      <Icon iconName={props.icon} className={styles.icon} />
      <em>{props.text}</em>
    </p>
  );
};
